class Rank {
    id = null;
    name = '';
    abbreviation = '';
    rank_category_id = 1;
    active = true;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Rank;
